// libs
import { useEffect } from "react";

// defs
interface ITouchProps {
    allowTouchCapture: boolean;
    onTouchOut: () => void;
    parentRef: React.RefObject<HTMLElement>;
}

const useTouchOut = ({ allowTouchCapture, onTouchOut, parentRef }: ITouchProps) => {
    useEffect(() => {
        const onCaptureEvent = (e: MouseEvent | TouchEvent) => {
            if (
                parentRef.current !== null &&
                parentRef.current.contains(e.target as Node) === false
            ) {
                onTouchOut();
            }
        };

        if (allowTouchCapture) {
            document.addEventListener("touchstart", onCaptureEvent);
        }

        return () => {
            if (allowTouchCapture) {
                document.removeEventListener("touchstart", onCaptureEvent);
            }
        };
    }, [onTouchOut, allowTouchCapture, parentRef]);
};

export default useTouchOut;
